<template>
  <div class="preview-panel">
    <div class="module-list">
      <div
        v-for="item in modules"
        :key="item.key"
        class="module-card"
        :class="[
          item.type,
          { active: value === item.key }
        ]"
        @click="$emit('input', item.key)"
      >
        <img v-if="item.cover" class="module-cover" :src="item.cover" alt="">
        <div class="module-main">
          <span class="plus">+</span>
          <span>{{ item.label }}</span>
        </div>
        <div v-if="item.actions && item.actions.length" class="module-actions">
          <a
            v-for="action in item.actions"
            :key="action"
            class="action-link"
            @click.stop.prevent="$emit('action', { action, key: item.key })"
          >{{ action }}</a>
        </div>
      </div>
    </div>
    <div class="preview-footer">
      <a-button block @click="$emit('preview')">效果预览</a-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActivityPreviewPanel',
  props: {
    value: {
      type: String,
      default: ''
    },
    modules: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped lang="less">
.preview-panel {
  display: flex;
  flex-direction: column;
  width: 420px;
  flex-shrink: 0;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  padding: 16px;
}

.module-list {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 2px;
}

.preview-footer {
  margin-top: 16px;
  padding-top: 12px;
}

.module-card {
  position: relative;
  min-height: 130px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  font-size: 13px;
  cursor: pointer;
  // border: 1px solid #e8e8e8;
  background: #f5f5f5;
  overflow: hidden;

  &.active {
    background: #fff7e6;
    border-color: #fa8c16;
    color: #d46b08;
    box-shadow: 0 0 0 1px #fa8c16 inset;
  }
}

.module-cover {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
  opacity: 0.85;
}

.module-card .module-main {
  position: relative;
  z-index: 1;
  padding: 6px 12px;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  background: rgba(0, 0, 0, 0.72);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.28);
}

.module-card.active .module-main {
  color: #fff;
  background: #fa8c16;
  box-shadow: 0 2px 8px rgba(250, 140, 22, 0.45);
}

.module-main {
  display: flex;
  align-items: center;
  gap: 4px;

  .plus {
    font-size: 16px;
    line-height: 1;
  }
}

.module-actions {
  position: absolute;
  z-index: 2;
  right: 8px;
  bottom: 8px;
  display: flex;
  gap: 6px;
  padding: 4px 6px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.72);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.28);
}

.action-link {
  padding: 2px 8px;
  border-radius: 2px;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  color: #fff;
  background: #fa8c16;
  transition: background 0.2s;

  &:hover {
    color: #fff;
    background: #d46b08;
  }

  &:last-child {
    background: #ff4d4f;

    &:hover {
      background: #cf1322;
    }
  }
}
</style>
